import { useMemo } from 'react';

import {
    AdditionalDefault,
    createStaticDataProvider as createMagritteStaticDataProvider,
    DataProvider,
    filterParents,
    fromTree as fromTreeMagritte,
    ModelData as MagritteModelData,
    TreeCollection as MagritteTreeCollection,
    StaticDataFetcherItem,
} from '@hh.ru/magritte-ui';

import { selectErirClassificationCatalog } from 'store/autoReducers';
import { useSelector } from 'store/utils';

interface UseErirCatalogData {
    collection: MagritteTreeCollection<AdditionalDefault>;
    provider: DataProvider<StaticDataFetcherItem>;
    leavesIds: string[];
}

const addNumberingToTree = (items: MagritteModelData[]): MagritteModelData[] => {
    return items.map((item) => {
        const formattedText = `${item.id}. ${item.text}`;
        return {
            ...item,
            text: formattedText,
            items: item.items ? addNumberingToTree(item.items) : undefined,
        };
    });
};

export const useErirCatalogData = (): UseErirCatalogData => {
    const erirClassificationCatalog = useSelector(selectErirClassificationCatalog);

    return useMemo(() => {
        const catalogWithNumbering = addNumberingToTree(erirClassificationCatalog);

        const collection = fromTreeMagritte<AdditionalDefault>(catalogWithNumbering);
        const leavesIds = filterParents(
            collection,
            collection.toList().map((item) => item.id)
        );

        return {
            collection,
            provider: createMagritteStaticDataProvider(
                collection
                    .toList()
                    .filter((item) => leavesIds.includes(item.id))
                    .map((item) => ({
                        value: item.id,
                        text: item.text,
                    }))
            ),
            leavesIds,
        };
    }, [erirClassificationCatalog]);
};
